<template>
  <div>
    <div :class="$style.box" :style="{backgroundImage: `url(${bg})`}">
      <!-- 信息部分 -->
      <div :class="$style.info">
        <p>{{name}}</p>
        <p>{{"账号：" + userInfo.user_name}}</p>
        <div :class="$style.sure" @click="out">确定</div>
        <!-- 测试用：解绑 -->
        <!-- <div :class="$style.sure" @click="remove">解绑</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import wxInit from "@/libs/wxinit";
import { mapState, mapMutations } from "vuex";
import { remove } from "@/apis/sdkhb";
import { sort_ASCII } from "@/libs/utils";
import { CDN_URL } from "@/config";
import { Toast } from "vant";

export default {
  data() {
    return {
      name: "账号信息",
      bg: `${CDN_URL}/packet/bg2.jpg?v=3`
    };
  },
  mounted() {
    wxInit();
  },
  computed: {
    ...mapState("sdkhb", {
      userInfo: "userInfo"
    })
  },
  methods: {
    ...mapMutations("sdkhb", {
      CLEAR_USERINFO: "CLEAR_USERINFO"
    }),
    async remove() {
      const data = {
        user_id: this.userInfo.user_id,
        open_id: this.userInfo.open_id
      };
      const r = await remove({
        ...data,
        sign: sort_ASCII(data)
      });
      if (r.ret === 1) {
        Toast("解绑成功！", 2000);
        this.CLEAR_USERINFO();
        
        this.$router.replace({ name: this.$route.name == 'sdkhb-role' ? "sdkhb-login" : "sdkhb-wxLogin" });
      }
    },
    out() {
      window.wx.closeWindow();
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
  .info {
    width: 300px;
    height: 240px;
    background-color: rgba(255, 255, 255, 0.9);
    position: absolute;
    top: 180px;
    left: 50%;
    display: block;
    margin-left: -150px;
    box-sizing: content-box;
    border-radius: 10px;
    > p:nth-child(1) {
      width: 100%;
      text-align: center;
      line-height: 30px;
      font-size: 16px;
    }
    > p:nth-child(2) {
      width: 100%;
      font-size: 18px;
      font-weight: bold;
      line-height: 50px;
      text-align: center;
      margin-top: 30px;
      margin-bottom: 20px;
    }
    .sure {
      width: 226px;
      height: 42px;
      background: #399fff;
      border-radius: 9px;
      line-height: 42px;
      text-align: center;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      margin-left: 50%;
      transform: translateX(-113px);
      margin-top: 10px;
    }
  }
}
</style>